<template>
  <v-card class="pa-2">
    <v-card-text>
      <v-layout row wrap>
        <v-flex>
          <h2 class="mb-2">{{ $t('customers_booking') }}</h2>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn
            fab
            outline
            small
            color="primary"
            :loading="loading"
            @click="getBookingCalendarUser"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <div v-if="loading">
        <div class="spinner text-xs-center mb-5 mt-5">
          <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
        </div>
      </div>
      <div v-else style="margin-bottom: 10px;">
        <v-data-table
          :rows-per-page-items="[25, 40, 50, 100]"
          :loading="loading"
          :headers="headers"
          :items="dataDetail"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">
                <v-avatar :size="40">
                  <img
                    :src="props.item.user_image_url || '/static/img/assets/livechat/profile.png'"
                  />
                </v-avatar>
                {{ props.item.user_first_name }} {{ props.item.user_last_name }}
              </td>
              <td class="text-xs-left">
                {{ dateFormat(props.item.created_at, 'dddd, D MMMM, YYYY h:mm A') }}
              </td>
              <td class="text-xs-left">{{ props.item.user_app }}</td>
              <td class="text-xs-left">
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small ma-1"
                  @click="onCancelBooking(props.item)"
                >
                  <i class="fa fa-trash middle"></i>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="text-xs-center mt-3">
        <v-btn outline color="grey" :loading="loading" @click="onEditDialog">{{
          $t('cancel')
        }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
  props: ['value'],
  data() {
    return {
      infoDetail: this.value,
      dataDetail: [],
      loading: false,
      headers: [
        { text: this.$t('Name and Surname'), value: 'username' },
        { text: this.$t('booking_date'), value: 'time', align: 'left' },
        { text: this.$t('booking_platform'), value: 'app', align: 'left' },
        { text: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted() {
    const vm = this
    vm.getBookingCalendarUser()
  },
  methods: {
    async getBookingCalendarUser() {
      const vm = this
      vm.loading = true
      vm.data = null
      const data = {
        pageId: vm.selectedBot.pageid,
        booking_config_id: vm.infoDetail ? vm.infoDetail.BookingId : '',
        sub_booking_config_id: vm.infoDetail ? vm.infoDetail.id : ''
      }
      let response = await api.getBookingCalendarUser(data)
      if (response.success && response.result) {
        vm.dataDetail = response.result
      }
      vm.loading = false
    },
    onEditDialog() {
      const vm = this
      vm.$emit('closeDetailDialog')
    },
    dateFormat: function(date, format) {
      const vm = this
      return dayjs(date)
        .locale(vm.currentLang)
        .format(format)
    },
    async onCancelBooking(customerDetail) {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to cancel {name}?', {
          name: `${customerDetail.user_first_name} ${customerDetail.user_last_name} ${vm.dateFormat(
            customerDetail.created_at,
            'DD/MM/YYYY HH:mm'
          )}`
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        const res = await api.deleteBookingCalendarUser({
          pageId: vm.selectedBot.pageid,
          booking_config_id: vm.infoDetail ? vm.infoDetail.BookingId : '',
          sub_booking_config_id: vm.infoDetail ? vm.infoDetail.id : '',
          userid: customerDetail.userid
        })
        if (res.success) {
          vm.dataDetail = vm.dataDetail.filter(item => item.userid !== customerDetail.userid)
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `${vm.$t('booking')} ${customerDetail.user_first_name} ${
              customerDetail.user_last_name
            } ${vm.dateFormat(customerDetail.created_at, 'DD/MM/YYYY HH:mm')} ${vm.$t(
              'has_been_deleted'
            )}`,
            type: 'success'
          })

          vm.loading = false
        } else {
          vm.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/calendar/DetailBooking.vue